/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsTransferUp = createReactComponent("outline", "arrows-transfer-up", "IconArrowsTransferUp", [["path", { "d": "M7 21v-6", "key": "svg-0" }], ["path", { "d": "M20 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M17 3v18", "key": "svg-2" }], ["path", { "d": "M10 18l-3 3l-3 -3", "key": "svg-3" }], ["path", { "d": "M7 3v2", "key": "svg-4" }], ["path", { "d": "M7 9v2", "key": "svg-5" }]]);

export { IconArrowsTransferUp as default };
//# sourceMappingURL=IconArrowsTransferUp.mjs.map
